"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncSome = asyncSome;
exports.default = void 0;

var _asyncIterable = require("../../internal/async-iterable");

async function asyncSome(iterable, func) {
  let c = 0;

  for await (const item of iterable) {
    if (await func(item, c++)) {
      return true;
    }
  }

  return false;
}

var _default = (0, _asyncIterable.asyncIterableCurry)(asyncSome, {
  reduces: true
});

exports.default = _default;